import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { UitkCheckbox } from "uitk-react-switch";
import { HotelWizardStateProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

const CheckboxTracked = FlexClickTracker(UitkCheckbox);

export interface HotelAddFlightCheckboxProps extends HotelWizardStateProps {
  onChange: () => void;
  updatePackageOnReflection: () => void;
}

export const HotelAddFlightCheckbox = observer(
  ({ hotelWizardState, onChange, updatePackageOnReflection }: HotelAddFlightCheckboxProps) => {
    const { formatText } = useLocalization();

    const handleChange = () => {
      hotelWizardState.toggleAddAFlightCheckbox();
      onChange();
      updatePackageOnReflection();
    };

    return (
      <UitkLayoutFlexItem>
        <CheckboxTracked
          id="add-flight-switch"
          checked={hotelWizardState.isAddAFlightChecked}
          onChange={handleChange}
          disabled={hotelWizardState.isMultiplePlacesChecked}
          moduleName="WizardHotelPWAv2"
          rfrr="SoftPackage_Flight"
        >
          {formatText(locKeys.addFlightLabel)}
        </CheckboxTracked>
      </UitkLayoutFlexItem>
    );
  }
);
